import { ChangeEvent, ReactElement } from 'react';

interface Props {
  Icon: HeroIconType;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Tile = ({
  Icon,
  label,
  description,
  checked,
  onChange,
}: Props): ReactElement => (
  <label
    data-selected={checked ? checked : undefined}
    htmlFor={label}
    className="flex flex-col p-3 group outline-grey-t-700 rounded-xs outline hover:outline-primary-400 active:shadow-focused data-selected:outline-2 data-selected:outline-primary-400 data-selected:bg-primary-1000 data-selected:hover:bg-primary-900"
  >
    <div className="mb-2 flex justify-between items-start">
      <Icon className="group-data-selected:text-primary-400 size-6 group-hover:text-primary-400" />
      <input
        type="radio"
        hidden
        id={label}
        checked={checked}
        onChange={onChange}
      />
      <div className="flex items-center justify-center rounded-full border-2 border-secondary-300 h-5 w-5 group-hover:border-white">
        <div className="hidden group-hover:bg-white group-data-selected:block h-2.5 w-2.5 bg-secondary-300 rounded-full" />
      </div>
    </div>
    <p className="leading-6 mb-1">{label}</p>
    {description && <span className="text-sm">{description}</span>}
  </label>
);
